import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'reactstrap';
import FormProfile from './Form';
import AvatarProfile from './Avatar';
import { useUser } from 'Context/UserContext';

const ProfileScreen = ({ handleNavigation, user, onSubmit, handleUpload, uploadedFiles }) => {
	const {usuario} = useUser()

	return (
		<Row>
			<Col xl={4} lg={12} md={12}>
				<AvatarProfile
					uploadedFiles={uploadedFiles}
					handleUpload={handleUpload}
					user={user}
					handleNavigation={page => handleNavigation(page)}
				/>
			</Col>
			<Col xl={8} lg={12} md={12}>
				<FormProfile user={usuario} onSubmit={onSubmit} />
			</Col>
		</Row>
	);
};

ProfileScreen.propTypes = {
	handleNavigation: PropTypes.func.isRequired,
	onSubmit: PropTypes.func.isRequired,
	user: PropTypes.PropTypes.shape({}).isRequired,
};

export default ProfileScreen;